import moment from "moment";
import api from "../../api";

export function getMyTeam() {
  return api.get(`myTeam`);
}

export function getExotelData(sd, ed) {
  const encodedStartDate = encodeURIComponent(sd);
  const encodedEndDate = encodeURIComponent(ed);
  return api.get(
    `exotel-data?startDate=${encodedStartDate}&endDate=${encodedEndDate}`
  );
}

export function getExotelStats(sd, ed) {
  const encodedStartDate = encodeURIComponent(sd);
  const encodedEndDate = encodeURIComponent(ed);
  return api.get(
    `exotel-stats?startDate=${encodedStartDate}&endDate=${encodedEndDate}`
  );
}

export function getExotelStatsForPro(sd, ed) {
  const encodedStartDate = encodeURIComponent(sd);
  const encodedEndDate = encodeURIComponent(ed);
  return api.get(
    `exotel-stats?startDate=${encodedStartDate}&endDate=${encodedEndDate}&aggregate=true`
  );
}

export function getDoctorSlots(sd, ed, tab, status, users, payment_status) {
  return api.get(
    `v4/doctor-slot-list?sd=${sd}&ed=${ed}&tab=${tab}${
      status.length ? `&status=${status.toString()}` : ``
    }
    ${
      payment_status.length
        ? `&payment_status=${payment_status.toString()}`
        : ``
    }
    ${users.length ? `&user=${users.toString()}` : ``}
     `
  );
}

export function getAllCommunities() {
  return api.get(`get-all-communities`);
}

export function getCommunityHistory(startDate, endDate) {
  return api.get(`community-history`, {
    params: {
      startDate,
      endDate,
    },
  });
}

export function addCommunity(payload) {
  return api.post("create-community", payload);
}

export function addBulkCommunity(payload) {
  return api.post("bulk-add-community-member", payload);
}

export function getCategoryData() {
  return api.get("get-category");
}
export function getSearchData(key) {
  return api.get(`dispatchSearchItems?searchKey=${encodeURIComponent(key)}`);
}
export function getWarehousedata() {
  return api.get(`getWarehouses`);
}
export function getShippingItemsData(query, pageNumber) {
  return api.get(
    `pendingShippingItems?${query}pageSize=20&pageNumber=${pageNumber}`
  );
}
export function postOrderRequest(orders, type) {
  return api.post(`process-oad-order?type=${type}`, orders);
}

export function fetchUser(role) {
  return api.get(`v2/users?userRole=${role}&page=1`);
}

export function getZeroValueData(pageNo, startDate, endDate, option) {
  return api.get(
    `get-zero-value-orders-v2?pageSize=10&pageNumber=${pageNo}&startDate=${startDate}&endDate=${endDate}&category=${option}`
  );
}

export function getCancelledData(pageNo, startDate, endDate) {
  return api.get(
    `get-cancelled-orders?pageSize=10&pageNumber=${pageNo}&startDate=${startDate}&endDate=${endDate}`
  );
}

export function getRTOData(pageNo, startDate, endDate) {
  return api.get(
    `get-rto-orders?pageSize=10&pageNumber=${pageNo}&startDate=${startDate}&endDate=${endDate}`
  );
}

export function getLostDamagedBy(pageNo, startDate, endDate, option) {
  return api.get(
    `get-lost-damaged-orders?pageSize=10&pageNumber=${pageNo}&startDate=${startDate}&endDate=${endDate}&category=${option}`
  );
}

export function downloadRevenueReport(payload) {
  return api.post(`donwload-revenue-report`, payload);
}

export function updateCategory(payload) {
  return api.put(`update-category`, payload);
}

export function createCatSubcat(payload) {
  return api.post(`create-category`, payload);
}

export function deleteCategory(payload) {
  return api.put(`delete-category`, payload);
}

export function taskApi(caseId) {
  return api.get(`allTask/${caseId}`);
}

export const getAllGroups = () => {
  return api.get("get-all-ticketing-groups");
};

export const updateMemberActiveStatus = (payload) => {
  return api.put("update-group-member-status", payload);
};

export const deleteMemberFromGroup = (payload) => {
  return api.put("/remove-member-from-group", payload);
};

export const createTicketngGroup = (payload) => {
  return api.post("/create-group", payload);
};

export const getGroupAssignedToSubcategory = () => {
  return api.get("/get-all-subcategories-groups");
};

export const assignGropuToSubcateory = (payload) => {
  return api.post("/assign-group-to-subcategory", payload);
};

export const removeSubcategoryGroup = (subcatAndGroup) => {
  return api.post("/remove-subcategory-ticket-group", subcatAndGroup);
};

export const removeTicketGroup = (payload) => {
  return api.post("/remove-ticket-group", payload);
};

export const getTicketGroupLogs = (pageNumber) => {
  return api.get(`/ticket-group-logs?pageNumber=${pageNumber}`);
};

export const prescribedPatientsCountApi = (startDate, endDate) => {
  return api.get(`/prescribed_patients_count?startDate=${startDate}T18%3A30%3A00.000Z&endDate=${endDate}T18%3A29%3A59.999Z`);
}

export const allTaskComponent=()=>{
  return api.get(`allComponents`);
}

export const userSegmentSlug = (caseId) =>{
  return api.get(`userSegmentsAndSlug/${caseId}`);
};

export const getTicketDashboardData = (payload) => {
  return api.post('/get-ticket-dashboard-data', payload);
};

export const getAuthDashBoardLeadStats= (reportDate) => {
  return api.get(`/api/authDashboard/lead-stats?reportDate=${reportDate}`);
};

export const getFailedTicket = (sd, ed, pageNumber, query) => {
  const queryString = query && query.length ? `&${query}`:'';
    return api.get(`/get-failed-tickets/${sd}/${ed}?pageNumber=${pageNumber}${queryString}`);
}

export const deleteFailtedTicketBackup = (id) => {
    return api.delete(`/delete-failed-ticket/${id}`);
}

export const doctorFollowUp = (id, selectedDate) => {
  const formattedDate = moment(selectedDate).startOf('day').toISOString();
return api.get(`/get-followUp-slots/${id}?date=${formattedDate}`);
};

export function getCommunityEngagements(params) {
  return api.get('community-engagements', { params });
}

export function getCommunityEngagementsAssignees() {
  return api.get('api/clinic/employee-list');
}

export function updateCommunityEngagementsAssignees(payload){
  return api.put('reassign-community-engagements', payload);
}